import { Grid } from '@mantine/core';
import { useSelector } from 'react-redux';
import BarChart from '../../../components/Charts/BarChart';
import SummaryCard from '../../../components/Dashboard/SummaryCard';
import DashboardsCommon from '../../../components/DashboardsCommon';
import statsToSummary from '../../../constants/StatsToSummary';

const MarketingTab = ({ stats, prevStats }) => {
  const domain = useSelector((state) => state.domain);
  const whatsappAccount = useSelector((state) => state.whatsapp.account);

  return (
    <>
      <Grid data-tour="summaryCardMarketingTab" pt="sm">
        <SummaryCard
          currentPeriodData={statsToSummary(stats.totals.marketingChannels)}
          previousPeriodData={statsToSummary(prevStats.totals.marketingChannels)}
          currency=""
          size="auto"
        />
      </Grid>
      <Grid mt="md">
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }} data-tour="emailsActivityChart">
              <DashboardsCommon
                stats={stats.emails.filter(
                  (stat) => stat.id !== 'emailSends' && stat.id !== 'permanentBounces' && stat.id !== 'transientBounces'
                )}
                chartTitle="Emails Activity"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.emails.filter((stat) => stat.id === 'emailSends')}
                chartTitle="Emails Sends"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <BarChart
                data={stats.weekDailyStatistics.find((stat) => stat.id === 'emailOpen')}
                title="Email Opens by Weekday"
                expand={true}
                type={'card'}
                keys={['emailOpen']}
                index={'weekDay'}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <BarChart
                data={stats.hourDailyStatistics.find((stat) => stat.id === 'emailOpen')}
                title="Emails Opens by Hours"
                expand={true}
                type={'card'}
                keys={['emailOpen']}
                index={'hour'}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
      <Grid mt="md">
        <Grid.Col span={12} data-tour="emailBouncesCharts">
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.emails.filter((stat) => stat.id === 'permanentBounces')}
                chartTitle="Email Permanent Bounces"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.emails.filter((stat) => stat.id === 'transientBounces')}
                chartTitle="Email Transient Bounces"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
      <Grid>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.pushNotifications.filter((stat) => stat.id !== 'pushNotificationSends')}
                chartTitle="Push Notifications Activity"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.pushNotifications.filter((stat) => stat.id === 'pushNotificationSends')}
                chartTitle="Push Notifications Sends"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
      {!domain.domain.textMessageSender ||
      !domain.domain.textMessageSenderUser ||
      !domain.domain.textMessageSenderPassword ? null : (
        <Grid>
          <Grid.Col span={12}>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.textMessages.filter((stat) => stat.id !== 'textMessageSends')}
                  chartTitle="Text Messages Activity"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.textMessages.filter((stat) => stat.id === 'textMessageSends')}
                  chartTitle="Text Messages Sends"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      )}
      {!domain.domain.viberMessageSender ||
      !domain.domain.viberMessageSenderUser ||
      !domain.domain.viberMessageSenderPassword ? null : (
        <Grid>
          <Grid.Col span={12}>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.viberMessages.filter((stat) => stat.id !== 'viberMessageSends')}
                  chartTitle="Viber Messages Activity"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.viberMessages.filter((stat) => stat.id === 'viberMessageSends')}
                  chartTitle="Viber Messages Sends"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      )}
      {!whatsappAccount || !whatsappAccount.whatsappAccountId ? null : (
        <Grid>
          <Grid.Col span={12}>
            <Grid>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.whatsappMessages.filter((stat) => stat.id !== 'whatsappMessageSends')}
                  chartTitle="WhatsApp Messages Activity"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, sm: 6 }}>
                <DashboardsCommon
                  stats={stats.whatsappMessages.filter((stat) => stat.id === 'whatsappMessageSends')}
                  chartTitle="WhatsApp Messages Sends"
                  lineStacked={false}
                  expand={true}
                  type={'card'}
                />
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      )}
      <Grid>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.webhooks.filter((stat) => stat.id !== 'webhookSends')}
                chartTitle="Webhooks Activity"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 6 }}>
              <DashboardsCommon
                stats={stats.webhooks.filter((stat) => stat.id === 'webhookSends')}
                chartTitle="Webhooks Sends"
                lineStacked={false}
                expand={true}
                type={'card'}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default MarketingTab;
